import { render, staticRenderFns } from "./PdvCall.vue?vue&type=template&id=6fe9c124&scoped=true"
import script from "./PdvCall.vue?vue&type=script&lang=js"
export * from "./PdvCall.vue?vue&type=script&lang=js"
import style0 from "./PdvCall.vue?vue&type=style&index=0&id=6fe9c124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe9c124",
  null
  
)

export default component.exports